import { MutableRefObject } from 'react';
import { STATIC_ACTIONS } from '~/Constants/Actions.constants';
import { Tour } from '~/Models/interfaces/Tour.enum';
import { INeoAction } from '~/store/Actions.interface';

export interface ProductToursState {
  activeTour?: Tour;
  ref?: MutableRefObject<null>;
}

const INITIAL: ProductToursState = {
  activeTour: undefined,
  ref: undefined,
};

export default (state: ProductToursState = INITIAL, action: INeoAction): ProductToursState => {
  const { name, payload } = action;

  switch (name) {
    case STATIC_ACTIONS.SET_PRODUCT_TOUR:
      return { ...state, activeTour: payload, ref: undefined };
    case STATIC_ACTIONS.SET_PRODUCT_TOUR_REF:
      return { ...state, ref: payload };
    case STATIC_ACTIONS.CLEAR_PRODUCT_TOURS:
      return INITIAL;
    default:
      return state;
  }
};
